export const environment = {
  production: false,
  baseBackendUrl: 'https://dev.bi.empresascec.com/backend'
};



